module.exports = __webpack_public_path__ + "img/rpx.df89cb07.svg";